// extracted by mini-css-extract-plugin
module.exports = {"main":"Layout_main__Khf_P","footer":"Layout_footer__wnUx_","max-width-container":"Layout_max-width-container__Ineht","page-container":"Layout_page-container__TMQi9"};